module.exports = __webpack_public_path__ + "img/yancheng.fac2ea0.png";